import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAppConfigs } from './app-config-thunk';

const AppConfig = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAppConfigs());
    }, []);
    return null;
};
export default AppConfig;
